<template>
  <div>
    <v-card
      v-if="!$emManutencao"
      class="elevation-2"
      style="border-radius: 8px"
    >
      <v-layout align-center justify-space-around column fill-height>
        <v-card-text class="pa-4">
          <v-flex class="text-left">
            <div v-if="showProgress">
              <v-spacer></v-spacer>
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <h4>Cadastrar currículo</h4>
            <p>
              Para cadastrar seu currículo basta informar seu CPF e clicar em
              logar!
            </p>
            <v-divider></v-divider>
            <h4 class="pt-2">Atualizar currículo</h4>
            <p>
              Se você já se cadastrou e deseja atualizar o seu currículo,
              informe o seu CPF, que será solicitado a sua senha.
            </p>
            <v-divider></v-divider>
          </v-flex>
          <v-flex>
            <v-form ref="form" class="pt-4" v-on:submit.prevent="logar">
              <v-text-field
                name="cpf"
                label="CPF"
                type="text"
                v-model="cpf"
                return-masked-value
                v-mask="mask"
                :rules="cpfRules"
                prepend-icon="mdi-account-box-outline"
                @change="verificaCPFdigitado"
              ></v-text-field>
              <div v-if="showSenha">
                <v-text-field
                  name="senha"
                  v-model="senha"
                  label="Senha"
                  type="password"
                  :rules="senhaRules"
                  prepend-icon="mdi-lock-question"
                ></v-text-field>
              </div>
              <div v-if="showSenhaCadastro">
                <v-text-field
                  name="senha"
                  v-model="senha"
                  label="Senha"
                  type="password"
                  prepend-icon="mdi-lock-question"
                  :rules="[(v) => !!v || 'Campo Obrigatório!']"
                ></v-text-field>
                <v-text-field
                  name="confirmacao"
                  v-model="confirmacao"
                  label="Confirmação da senha"
                  type="password"
                  prepend-icon="mdi-lock-question"
                  :rules="[(v) => !!v || 'Campo Obrigatório!']"
                ></v-text-field>
              </div>
              <vue-recaptcha
                style="width: 100%; text-align: center"
                :loadRecaptchaScript="true"
                ref="invisibleRecaptcha"
                @verify="onVerify"
                @expired="onExpired"
                sitekey="6LfMvMIUAAAAACLaEk4qg0AJ4suS5RUI6NY9uL4a"
              ></vue-recaptcha>
              <v-btn
                :loading="loading"
                :disabled="loading"
                block
                color="primary"
                class="mt-2"
                :class="this.$vuetify.theme.themes.light.buttonText"
                @click="logar"
                >Logar</v-btn
              >
            </v-form>
          </v-flex>
          <v-flex v-if="$msgEsquecimentoSenha != ''" class="text-left">
            <p class="mb-0 font-weight-bold red--text">
              {{ $msgEsquecimentoSenha }}
            </p>
          </v-flex>
        </v-card-text>
      </v-layout>
    </v-card>
    <v-container v-else fluid fill-height grid-list-xl>
      <v-layout align-center justify-center>
        <v-flex>
          <v-layout row wrap align-content-start justify-center fill-height>
            <v-flex xs12 class="pa-3">
              <v-card class="mx-auto elevation-2">
                <h2 class="pt-2">Página em Manutenção!</h2>
                <v-card-text class="text-justify" style="font-size: 20px">{{
                  $msgManutencao
                }}</v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Aviso!</v-card-title
        >

        <v-card-text class="pt-1">
          {{ dialogMessage }}
          <br v-if="this.enviar && this.temFone" />
          <br v-if="this.enviar && this.temFone" />

          <span v-if="this.enviar && this.temFone">{{
            dialogMessageTelefone
          }}</span>

          <br v-if="this.enviar && this.temFone" />
          <br v-if="this.enviar && this.temFone" />

          <span v-if="this.enviar && this.temFone">ou</span>

          <br v-if="this.enviar" />
          <br v-if="this.enviar" />

          <span v-if="this.enviar">{{ dialogMessageEmail }}</span>

          <br v-if="this.enviar" />
          <br v-if="this.enviar" />

          <span v-if="this.enviar">Como deseja recuperar sua senha?</span>

          <v-row justify="space-around">
            <v-radio-group v-model="metodoRecuperacao" row v-if="this.enviar">
              <v-radio
                label="SMS"
                value="1"
                color="primary"
                :disabled="!temFone"
              ></v-radio>
              <v-radio
                label="E-mail"
                value="2"
                :disabled="!temEmail"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </v-row>

          <v-flex v-show="solicitaEmail">
            <v-form
              id="formEmail"
              ref="formEmail"
              v-model="valid"
              lazy-validation
              v-on:submit.prevent="enviarEmail"
            >
              <v-text-field
                name="email"
                label="E-mail"
                type="email"
                v-model="email"
                :rules="[emailRules.required, emailRules.emailValido]"
                prepend-icon="mdi-email"
                required
              ></v-text-field>
            </v-form>
          </v-flex>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions v-if="!enviar">
          <v-btn v-if="sms" color="primary" text @click="esqueceuSenha"
            >TROCAR SENHA</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">OK</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn
            v-if="sms"
            color="primary"
            text
            @click="
              dialog = false;
              enviar = false;
            "
            >CANCELAR</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            :disabled="loading || metodoRecuperacao < 1"
            color="primary"
            text
            @click="enviarRecuperacaoSenha"
            >ENVIAR</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      bottom
      left
      :timeout="8000"
      :color="snackbarColor"
      :vertical="false"
    >
      {{ mensagem }}
      <v-btn text @click="snackbar = false">OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import Home from "./Home";
import Service from "@/services/service.js";
import VagasEmpregoVue from "./VagasEmprego.vue";
export default {
  components: { VueRecaptcha },
  data: (vm) => ({
    enviar: false,
    valid: false,
    cpfRules: [(v) => !!v || "Preencha o cpf"],
    senhaRules: [(v) => !!v || "Preencha a senha"],
    emailRules: {
      required: (v) => !!v || "Preencha o email",
      emailValido: (v) => vm.validarEmail(v) || "E-mail inválido.",
    },
    showSenhaCadastro: false,
    confirmacao: null,
    dialog: false,
    dialogMessage: "",
    service: new Service(),
    showSenha: false,
    senha: null,
    mask: "###.###.###-##",
    cpf: null,
    print: console.log,
    codPessoa: 0,
    showProgress: false,
    verifyed: false,
    sms: false,
    telefone: null,
    email: null,
    loading: false,
    snackbar: false,
    snackbarColor: "red",
    mensagem: "",
    solicitaEmail: false,
    temFone: false,
    temEmail: false,
    metodoRecuperacao: 0,
  }),
  methods: {
    onVerify() {
      this.verifyed = true;
    },
    onExpired() {
      this.verifyed = false;
    },
    consultarVagas() {
      this.$emit("home", VagasEmpregoVue);
    },
    validarEmail(email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
      return re.test(email);
    },
    verificaCPFdigitado(cpf) {
      if (!cpf) {
        this.showSenha = false;
        this.showSenhaCadastro = false;
      }
    },
    isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async enviarMSG() {
      this.loading = true;

      let response = await this.service.enviaSMS(this.codPessoa, this.telefone);

      if (response.data.retorno[0].estatus === "Sucesso") {
        this.dialogMessage = "SMS enviado com sucesso!";
      } else {
        this.dialogMessage = "Ops... Não foi possível enviar o SMS!";
      }

      this.sms = false;
      this.enviar = false;

      this.loading = false;
    },
    async enviarEmail() {
      try {
        this.$refs.formEmail.validate();

        if (this.email) {
          this.loading = true;

          let response = await this.service.enviaEmail(
            this.codPessoa,
            this.email
          );

          if (response.data.retorno[0].msgErro.split(" - ")[0] === "1") {
            this.dialogMessage = "E-mail enviado com sucesso!";
          } else {
            this.dialogMessage = "Ops... Não foi possível enviar o E-mail!";
          }

          this.sms = false;
          this.enviar = false;
          this.solicitaEmail = false;
          this.loading = false;
        }
      } catch (e) {
        console.log(e);
        this.mensagem = e;
        this.snackbarColor = "red";
        this.snackbar = true;
        this.loading = false;
      }
    },
    async enviarRecuperacaoSenha() {
      if (parseInt(this.metodoRecuperacao) === 1) {
        this.enviarMSG();
      } else if (parseInt(this.metodoRecuperacao) === 2) {
        this.enviarEmail();
      } else {
        this.mensagem = "Não foi possível recuperar a sua senha.";
        this.snackbarColor = "red";
        this.snackbar = true;
      }
    },
    async esqueceuSenha() {
      try {
        let response = await this.service.esqueceuSenha(this.codPessoa);

        if (response.data.retorno[0].estatus === "Sucesso") {
          var retornos = response.data.retorno[0].msgErro.split(";");

          if (retornos[0] === "0" && retornos[2] === "0") {
            this.dialogMessage =
              "Nenhuma opçao de recuperação de senha disponível. Entre em contato com a empresa.";

            this.dialogMessageTelefone = "";
            this.dialogMessageEmail = "";

            this.enviar = false;
            this.temFone = false;
            this.temEmail = true;
            this.telefone = "";
            this.email = "";
          } else {
            this.dialogMessage =
              "Opções disponíveis para recuperação de senha: \n";

            // Verificar se o cliente permite recuperação por SMS - EnvFile
            if (this.$recuperacaoSenhaSMS) {
              if (retornos[0] === "0") {
                this.dialogMessageTelefone =
                  "Não foi encontrado um número de telefone válido no seu cadastro.";
                this.temFone = false;
                this.telefone = "";
              } else {
                this.dialogMessageTelefone =
                  "Você pode recuperar sua senha, atráves de um SMS enviado para o número " +
                  retornos[1];
                this.temFone = true;
                this.telefone = retornos[0].split(" - ")[1];
              }
            } else {
              this.temFone = false;
            }

            if (retornos[2] === "0") {
              this.dialogMessageEmail =
                "Não foi encontrado um e-mail válido no seu cadastro.";
              this.temEmail = false;
              this.email = "";
            } else {
              this.dialogMessageEmail =
                "Você pode recuperar sua senha, atráves de um e-mail enviado para o endereço " +
                retornos[3];
              this.temEmail = true;
              this.email = retornos[2];
            }

            this.enviar = true;
          }
        } else {
          this.mensagem =
            "Ops... Não foi possível encontrar seu cadastro, revise seu login ou entre em contato com a empresa.";
          this.snackbar = true;
          this.snackbarColor = "red";
          this.loading = false;
        }
      } catch (e) {
        this.mensagem = "Erro Interno.";
        this.snackbar = true;
        this.snackbarColor = "red";
        this.loading = false;
      }
    },
    async logar() {
      if (this.verifyed) {
        if (this.$refs.form.validate()) {
          try {
            this.loading = true;
            this.solicitaEmail = false;
            var response;
            if (this.showSenha) {
              response = await this.service.validaSenha({
                codPessoa: this.codPessoa,
                senha: this.senha,
              });
              if (response.data.retorno[0].estatus === "Sucesso") {
                localStorage.setItem("codPessoa", this.codPessoa);
                localStorage.setItem("senha", this.senha);
                localStorage.setItem("cpf", this.cpf);
                if (this.tipo === "vaga") {
                  this.showProgress = true;
                  response = await this.service.setVaga(this.codVaga);
                  if (response.data.retorno[0].estatus === "Sucesso") {
                    this.showProgress = false;
                    this.loading = false;
                    this.$emit("close", true);
                  } else {
                    this.$emit(
                      "close",
                      false,
                      response.data.retorno[0].msgErro
                    );
                  }
                } else {
                  this.loading = false;
                  this.$emit("home", Home);
                }
              } else if (
                response.data.retorno[0].estatus === "Ja e empregado"
              ) {
                if (
                  response.data.retorno[0].msgErro.split(" - ").length === 3
                ) {
                  if (
                    response.data.retorno[0].msgErro.split(" - ")[0] === "4"
                  ) {
                    this.dialog = true;
                    this.loading = false;
                    this.dialogMessage =
                      "Ola, " +
                      response.data.retorno[0].msgErro.split(" - ")[2] +
                      ". " +
                      "Identificamos em nosso banco de dados que ja existe um cadastro com este CPF, no entanto não existe senha informada para este acesso. " +
                      "Por favor entre em contato com o RH de nossa empresa através do número (37) 3286 - 2600 para que seu cadastrado seja atualizado e uma senha seja implementada no seu cadastro. " +
                      "Obrigado!";
                  }
                }
              } else if (
                response.data.retorno[0].estatus === "Senha incorreta"
              ) {
                this.dialog = true;
                this.sms = true;
                this.dialogMessage = "Senha inválida";
                this.loading = false;
              }
            } else if (this.showSenhaCadastro) {
              if (this.senha === this.confirmacao) {
                if (process.env.VUE_APP_CLIENTE === "RICA"){
                   if (this.isNumber(this.senha)){
                    localStorage.setItem("codPessoa", 0);
                    localStorage.setItem("senha", this.senha);
                    localStorage.setItem("cpf", this.cpf);
                    this.$emit("home", Home);
                    this.loading = false;
                   } else{
                    this.loading = false;
                    this.dialog = true;
                    this.dialogMessage = "A senha deve conter apenas números!";
                   }
                } else{
                  localStorage.setItem("codPessoa", 0);
                  localStorage.setItem("senha", this.senha);
                  localStorage.setItem("cpf", this.cpf);
                  this.$emit("home", Home);
                  this.loading = false;
                }
              } else {
                this.loading = false;
                this.dialog = true;
                this.dialogMessage = "As senhas não conferem!";
              }
            } else {
              response = await this.service.validaCPF({ cpf: this.cpf });
              if (response.data.retorno[0].estatus === "Sucesso") {
                this.showSenha = true;
                this.loading = false;
                this.codPessoa = parseInt(
                  response.data.retorno[0].msgErro.split(" - ")[1]
                );
              } else if (response.data.retorno[0].estatus === "Ja e empregado") {
                if (
                  response.data.retorno[0].msgErro.split(" - ").length === 3
                ) {
                  if (
                    response.data.retorno[0].msgErro.split(" - ")[0] === "4"
                  ) {
                    this.dialog = true;
                    this.loading = false;
                    this.dialogMessage =
                      "Olá, " +
                      response.data.retorno[0].msgErro.split(" - ")[2] +
                      ". " +
                      "Não é possível atualizar os dados atraves dessa ferramenta! Esse CPF já pertence a um colaborador!";
                  }
                }
              } else if (response.data.retorno[0].estatus === "Sucesso sem senha") {
                if (
                  response.data.retorno[0].msgErro.split(" - ").length === 3
                ) {
                  if (
                    response.data.retorno[0].msgErro.split(" - ")[0] === "3"
                  ) {
                    this.dialog = true;
                    this.loading = false;
                    this.dialogMessage =
                      "Olá, " +
                      response.data.retorno[0].msgErro.split(" - ")[2] +
                      ". " +
                      "Não é possível atualizar os dados atraves dessa ferramenta! Seu cadastro não possui senha, entre em contato com a empresa!";
                  }
                }
              } else if (response.data.retorno[0].estatus === "Não encontrado") {
                if (
                  response.data.retorno[0].msgErro.split(" - ").length === 2
                ) {
                  if (
                    response.data.retorno[0].msgErro.split(" - ")[0] === "2"
                  ) {
                    this.dialog = true;
                    this.dialogMessage =
                      "Identificamos que seu CPF não está na base de dados. Favor criar uma senha para efetuar seu cadastro.";
                    this.showSenhaCadastro = true;
                    this.loading = false;
                  }
                }
              } else if (response.data.retorno[0].estatus === "Erro") {
                  this.dialog = true;
                  this.dialogMessage = response.data.retorno[0].msgErro;
                  this.loading = false;
              }
            }
          } catch (e) {
            this.mensagem = "Serviço Indisponível";
            this.snackbar = true;
            this.loading = false;
            console.log(e);
          }
        }
      }
    },
  },
  props: {
    source: String,
    tipo: String,
    codVaga: Number,
  },
};
</script>
